import { cdnBaseUrl } from './constants.js';
import toast from "react-hot-toast";
import { COMMON_DEEPLINK_ACTIONS } from "./constants";
import { hitDeeplinkExecutedV2 } from "./hitDeeplink";
import i18n from "i18next";
import moment from "moment";
// GET AWS ASSETS URL BY GIVING ASSET NAME AND FOLDER NAME
export const getAwsAssets = (assetName, folderName = "contentStoreCommon") => {
  const baseURL = `https://${cdnBaseUrl}-cloudn.classplus.co`;
  const webPrefix = "web";
  const courseWebviewPrefix = "courseWebview";

  // return `/api/proxyimage?url=${encodeURIComponent(`${baseURL}/${courseWebviewPrefix}/${folderName}/${assetName}`)}`;
  return `${baseURL}/${webPrefix}/${courseWebviewPrefix}${
    folderName ? `/${folderName}` : ""
  }/${assetName} `;
};

// GET HSL COLOR FROM A STRING (basically can be used for Avatars)
export const getColorFromString = (name, s = 50, l = 80) => {
  let hasher = 0;
  for (let i = 0; i < name.length; i++) {
    hasher = name.charCodeAt(i) + ((hasher << 5) - hasher);
  }
  let h = hasher % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

// FUNCTION TO HIT HAPTIC FEEDBACK ON MOBILE DEVICE
// time in ms B DEFAULT 40
export const hitHapticFeedback = (time = 40) => {
  window.navigator.vibrate && window.navigator.vibrate(time);
  // hitDeeplinkExecutedV2(null, JSON.stringify({
  //   screen: COMMON_DEEPLINK_ACTIONS.UTIL_HIT_HAPTIC_FEEDBACK,
  //   paramOne: `${ time } `
  // }), false)
};

// PARSING ERROR MESSAGE FROM API RESPONSE
// AND SHOW TOAST BY DEFAULT BASED ON showToast
// export const parseError = (err, showToast = true) => {
//   if (err.message === "Network Error") {
//     return "No internet connection";
//   }
//   // console.log(err, "*********error**parseError");
//   try {
//     if (showToast && window)
//       toast?.error(err?.response?.data?.message || "Something went wrong");
//   } catch (error) {}
//   return err?.response?.data?.message || "Something went wrong";
// };

// COMMON UTIL FOR GETTING REDUX ACTION BY TYPE AND PAYLOAD
export const getActionObject = (type, payload) => {
  return {
    type,
    payload,
  };
};

export const getLockedContentText = (
  scheduledFromDateText,
  scheduledToDateText,
  isPurchased,
  isScheduled,
  isLocked
) => {
  // let fromDate = moment(scheduledFromDateText).utc().format("DD MMM' YY");
  // let fromTime = moment(scheduledFromDateText).utc().format("h:mm A");
  // let toDate = moment(scheduledToDateText).utc().format("DD MMM' YY");
  // let toTime = moment(scheduledToDateText).utc().format("h:mm A");

  if (isPurchased) {
    if (isLocked) {
      return i18n.t(
        `utils.index.getLockedContentTextLocked`,
        `The content you’re trying to open has temporarily been locked by your teacher.
`
      );
    }
    if (isScheduled) {
      if (scheduledToDateText != null && scheduledFromDateText != null) {
        return (
          i18n.t(
            `utils.index.getLockedContentText1`,
            `This Content will be unlocked from `
          ) +
          " " +
          // `${fromDate} ${fromTime} - ${toDate} ${toTime}`
          `${scheduledFromDateText} - ${scheduledToDateText}`
        );
      } else if (scheduledFromDateText != null) {
        return (
          i18n.t(
            `utils.index.getLockedContentText2`,
            `This Content will be unlocked on `
          ) +
          " " +
          // `${fromDate} ${fromTime}`
          `${scheduledFromDateText}`
        );
      } else {
        return "";
      }
    }
  } else {
    if (isLocked) {
      return i18n.t(
        `utils.index.getLockedContentTextNew`,
        `The content you’re trying to open is locked. Buy the course for complete access. 
`
      );
    } else if (isScheduled) {
      if (scheduledToDateText != null && scheduledFromDateText != null) {
        return (
          i18n.t(
            `utils.index.getLockedContentText1`,
            `This Content will be unlocked from `
          ) +
          " " +
          // `${fromDate} ${fromTime} - ${toDate} ${toTime}`
          `${scheduledFromDateText} - ${scheduledToDateText}`
        );
      } else if (scheduledFromDateText != null) {
        return (
          i18n.t(
            `utils.index.getLockedContentText2`,
            `This Content will be unlocked on `
          ) +
          " " +
          // `${fromDate} ${fromTime}`
          `${scheduledFromDateText}`
        );
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
};

export const setFont = (/** @type {string} */ lang) => {
  const _lang = lang?.toLocaleLowerCase();
  let font;

  if (_lang === "vi") font = "Be Vietnam Pro";
  else font = "Noto Sans";

  const linkHref = `https://fonts.googleapis.com/css2?family=${font.replace(
    / /g,
    "+"
  )}:wght@400;500;600;700&display=swap`;

  let stylesheetAlreadyExists = false;
  const allLinkStylesheets = document.querySelectorAll(
    'link[rel="stylesheet"]'
  );

  for (let i = 0; i < allLinkStylesheets.length; ++i) {
    if (allLinkStylesheets[i].href === linkHref) {
      stylesheetAlreadyExists = true;
      break;
    }
  }

  if (!stylesheetAlreadyExists) {
    // const prevFontFamily = getComputedStyle(
    //   document.documentElement
    // ).getPropertyValue("--font-family");
    // const fallbackFont = prevFontFamily && prevFontFamily.split(",")[1].trim();

    const link = document.createElement("link");
    link.href = linkHref;
    link.rel = "stylesheet";
    document.head.appendChild(link);
    link.onload = () => {
      // document.documentElement.style.setProperty(
      //   "--font-family",
      //   `'${font}', ${fallbackFont || "sans-serif"}`
      // );
      document.documentElement.style.setProperty("--font-family", font);
    };
  }
};

export const validateEmail = (email) => {
  if (email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return false;
};

export function validateCity(city) {
  if (city) {
    var re = /[^a-zA-Z0-9 ]/;
    return !re.test(city);
  }
  return true;
}

export const addTokenInUrl = (str, token) => {
  let splitStr = str.split("{hash}");
  splitStr.splice(1, 0, token);
  let newStr = splitStr.join("");
  return newStr;
};
